import { ReactElement } from 'react';

import { ActionEventInterceptor, ModalConfirmButton } from '@dreryk/react-components';

import { useAccountAuthorizationModal } from '~libs.desktop.shared.account';
import { MedicalDocumentationPasswordDetailsShowModalInterceptor } from '~libs.desktop.shared.medical-documentation';

import { medicalDocumentationCreateTranslationKeys } from '../../../translations';
import { MedicalDocumentationCreateFormController } from '../MedicalDocumentationCreateForm.types';

import { useGenerateDocumentationCommand } from './useGenerateDocumentationCommand';

type MedicalDocumentationDownloadEncryptedActionProps = Pick<MedicalDocumentationCreateFormController, 'handleSubmit'> &
   Readonly<{
      patientId: number;
      onCreate: VoidFunction;
   }>;

export const MedicalDocumentationDownloadEncryptedAction = (
   props: MedicalDocumentationDownloadEncryptedActionProps
): ReactElement => {
   const { openAccountAuthorizationModal, renderAccountAuthorizationnModal } = useAccountAuthorizationModal();
   const {
      executeAsync: generateDocumentation,
      data: medicalDocumentationGenerationResult,
   } = useGenerateDocumentationCommand({
      patientId: props.patientId,
      onAuthenticationRequired: openAccountAuthorizationModal,
      encrypted: true,
   });

   return (
      <>
         <ActionEventInterceptor
            action={props.handleSubmit(generateDocumentation)}
            blockingOperation={medicalDocumentationCreateTranslationKeys.generatingDocumentation}
         >
            <MedicalDocumentationPasswordDetailsShowModalInterceptor
               filePassword={medicalDocumentationGenerationResult?.encryptionPassword ?? null}
               title={medicalDocumentationCreateTranslationKeys.createdAndSentPatientRecords}
            >
               <ModalConfirmButton
                  testId={'downloadEncrypted'}
                  label={medicalDocumentationCreateTranslationKeys.createPatientRecordsModal.actions.downloadEncrypted}
                  onClick={props.onCreate}
               />
            </MedicalDocumentationPasswordDetailsShowModalInterceptor>
         </ActionEventInterceptor>
         {renderAccountAuthorizationnModal({
            onAuthorization: props.handleSubmit(generateDocumentation),
         })}
      </>
   );
};
